import { match } from 'path-to-regexp';
import { AccessTypes } from '../../common/domain/accountAccessType';

export const prospectOnlyPaths = [
  '/signup/pro/subscription',
  '/signup/pro/payment/:secret',
  '/signUp/account-creation'
];

export const isProspectOnlyPath = (path: string): boolean =>
  prospectOnlyPaths.some(candidate => match(candidate)(path));

export const getValidProspectPath = (path = '', accessType?: AccessTypes): string => {
  const redirectOnInvalid = AccessTypes.Lite === accessType
    ? '/signup/account-creation'
    : '/signup/pro/subscription';
  return isProspectOnlyPath(path) ? path : redirectOnInvalid;
};
